export const Footer = () => {
  return (
    <footer className="d-flex justify-content-center">
      <p>kountriez.ge {new Date().getFullYear()} Some rights are violated</p>
    </footer>
  );
};
